(function () {
  'use strict';
  if (customElements.get('ss-withdrawal')) return;
  class Withdrawal extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var form = this.querySelector('form');
      var entry = this.querySelector('[data-entry]');
      if (!form || !entry) return;
      var self = this;
      var review = this.querySelector('[data-review]');
      var error = this.querySelector('[data-error]');
      var approved = null;
      function values() {
        var result = {};
        ['name', 'contract', 'email'].forEach(function (key) {
          result[key] = self.querySelector('[data-field="' + key + '"]').value.trim();
        });
        return result;
      }
      function edit() {
        approved = null;
        review.hidden = true;
        entry.hidden = false;
        self.querySelector('[data-field="name"]').focus();
      }
      this.querySelector('[data-check]').hidden = false;
      this.querySelector('[data-declaration]').hidden = true;
      this.querySelector('[data-edit]').addEventListener('click', edit);
      // Shopify handles delivery, spam protection and server-side success.
      // A client-side click alone must never produce a receipt or success.
      function check(event) {
        var next = values();
        var fingerprint = JSON.stringify(next);
        if (event.type === 'submit' && !review.hidden && approved === fingerprint && event.submitter === self.querySelector('[data-confirm]')) return;
        event.preventDefault();
        if (!form.reportValidity()) { edit(); return; }
        if (!next.name || !next.contract || !next.email) {
          edit();
          error.textContent = 'Bitte ergänze deinen Namen, die Bestellung und deine E-Mail-Adresse.';
          error.hidden = false;
          error.focus();
          return;
        }
        error.hidden = true;
        ['name', 'contract', 'email'].forEach(function (key) {
          self.querySelector('[data-review-' + key + ']').textContent = next[key];
        });
        approved = fingerprint;
        entry.hidden = true;
        review.hidden = false;
        self.querySelector('[data-review-heading]').focus();
      }
      this.querySelector('[data-check]').addEventListener('click', check);
      form.addEventListener('submit', check);
    }
  }
  customElements.define('ss-withdrawal', Withdrawal);
})();
